import { isEmpty } from "lodash";

export function isAllEmpty(...items: any[]) {
  return items.filter((v) => !isEmpty(v)).length === 0;
}
